<script lang="ts" setup>
import { onMounted } from 'vue'
import { useElementClick } from '@/composables/tracks/useElementClick'
import { resources } from '@/config/brands'
import { t } from '@/i18n/utils'

withDefaults(
  defineProps<{
    tab?: 'history' | 'home' | 'rewards' | 'member'
  }>(),
  {
    tab: 'home',
  },
)
const { elementClick } = useElementClick()

// 获取 Tab 图标配置（直接使用配置中的完整路径）
const tabIcons = resources.tabIcons

// 预加载所有图标，避免切换时闪烁
onMounted(() => {
  const iconsToPreload = [
    tabIcons.history,
    tabIcons.historyActive,
    tabIcons.home,
    tabIcons.homeActive,
    tabIcons.category,
    tabIcons.categoryActive,
    tabIcons.me,
    tabIcons.meActive,
  ]

  iconsToPreload.forEach((src) => {
    const img = new Image()
    img.src = src
  })
})
</script>

<template>
  <BasicFixedBottom>
    <div class="flex w-full text-n-text-3 bg-n-bg-pure tabbar-shadow">
      <div class="flex-1 text-center py-6px">
        <router-link
          :to="{ name: 'history' }" replace
          :class="{ 'text-n-primary font-bold': tab === 'history' }"
        >
          <div @click="elementClick('bookshelf')">
            <img
              :src="tab === 'history' ? tabIcons.historyActive : tabIcons.history"
              class="mx-a h-6 w-6"
              alt="Library"
            >
            <p class="mt-1 text-11px">
              {{ t('LibraryTab') }}
            </p>
          </div>
        </router-link>
      </div>
      <div class="flex-1 text-center py-6px">
        <router-link
          :to="{ name: 'home' }" replace
          :class="{ 'text-n-primary font-bold': tab === 'home' }"
        >
          <div @click="elementClick('novel')">
            <img
              :src="tab === 'home' ? tabIcons.homeActive : tabIcons.home"
              class="mx-a h-6 w-6"
              alt="Novel"
            >
            <p class="mt-1 text-11px">
              {{ t('NovelTab') }}
            </p>
          </div>
        </router-link>
      </div>
      <div class="flex-1 text-center py-6px">
        <router-link
          :to="{ name: 'member' }" replace
          class="flex-1 text-center py-6px"
          :class="{ 'text-n-primary font-bold': tab === 'member' }"
        >
          <div @click="elementClick('profile')">
            <img
              :src="tab === 'member' ? tabIcons.meActive : tabIcons.me"
              class="mx-a h-6 w-6"
              alt="Profile"
            >
            <p class="mt-1 text-11px">
              {{ t('ProfileTab') }}
            </p>
          </div>
        </router-link>
      </div>
    </div>
  </BasicFixedBottom>
</template>

<style scoped>
.tabbar-shadow {
  box-shadow: 0px -2px 7px 0px rgba(99, 100, 100, 0.1);
}
</style>
